import { Badge, Card, Row } from "react-bootstrap";
import { Target } from "../../models/Target";
import { MouseEventHandler, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Flex, Tooltip } from "antd";

type Props = {
  target: Target;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onEdit?: MouseEventHandler<HTMLButtonElement>;
  onDelete?: MouseEventHandler<HTMLButtonElement>;
}

export function TargetItem({ target, onClick, onEdit, onDelete }: Props) {
  const envCount = useMemo(() => Object.keys(target.env || {}).length, [target]);
  const affinitiesCount = useMemo(() => Object.keys(target.affinity || {}).length, [target]);
  const tolerationsCount = useMemo(() => (target.tolerations || []).length, [target]);

  return (
    <Card className="app-list-item overflow-hidden" style={{ cursor: "default" }} onClick={onClick}>
      <Card.Header className="list-item-header bg-target">
        <Flex align="center">
          <Badge bg="primary" className="shadow px-2 text-uppercase">{target.accessLevel}</Badge>
          {target.isDefault && <Badge bg="pink" className="shadow ms-auto text-uppercase">Default</Badge>}
        </Flex>
        <div className="list-item-icon">
          <FontAwesomeIcon icon={solid("crosshairs")} />
        </div>
        <div className="header-content py-3">
          <Tooltip title={target.name} mouseEnterDelay={0.3}>
            <h5 className="list-item-title">{target.name}</h5>
          </Tooltip>
          <p className="list-item-description line-clamp-2 mt-2">{target.description}</p>
          <div className="tags-wrapper my-2">
            <Badge className="bg-light bg-opacity-50 border text-dark me-1" pill={true}>
              <span className="align-items-center text-center">{envCount} Env var{envCount === 1 ? "" : "s"}</span>
            </Badge>
            <Badge className="bg-light bg-opacity-50 border text-dark me-1" pill={true}>
              <span className="align-items-center text-center">{affinitiesCount} Affinit{affinitiesCount === 1 ? "y" : "ies"}</span>
            </Badge>
            <Badge className="bg-light bg-opacity-50 border text-dark me-1" pill={true}>
              <span className="align-items-center text-center">{tolerationsCount} Toleration{tolerationsCount === 1 ? "" : "s"}</span>
            </Badge>
          </div>
        </div>
        <Row className="gx-0 justify-content-center mb-2">
          <Tooltip title="Edit Target" mouseEnterDelay={0.3}>
            <button className="circle-button ms-2" onClick={onEdit}>
              <FontAwesomeIcon size="sm" icon={solid('pen')} />
            </button>
          </Tooltip>
          <Tooltip title="Delete Target" mouseEnterDelay={0.3}>
            <button className="circle-button ms-2" onClick={onDelete}>
              <FontAwesomeIcon size="sm" icon={solid('trash')} />
            </button>
          </Tooltip>
        </Row>
      </Card.Header>
    </Card>
  )
}